/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-03",
    versionChannel: "nightly",
    buildDate: "2023-12-03T00:15:50.278Z",
    commitHash: "947785607955e8b2a39d5dbb7cb98f0d37f38eb2",
};
